module.exports = __webpack_public_path__ + "img/icon_map_37_on_010.704dd5e6.png";